import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgClass, UpperCasePipe } from '@angular/common';
import { OfferViewModel } from '../../../../core/models/offer-view.model';
import { OfferInfoMoleculeComponent } from '../../molecules/offer-info-molecule/offer-info-molecule.component';
import { UiButtonAtomComponent } from '../../atoms/ui-button/ui-button.component';
import { UiCheckListItemAtomComponent } from '../../atoms/ui-check-list-item/ui-check-list-item.component';
import { UiImageAtomComponent } from '../../atoms/ui-image/ui-image.component';
import { UiSponsorBadgeAtomComponent, UiSponsorBadgeVariant } from '../../atoms/ui-sponsor-badge/ui-sponsor-badge.component';

type LabelColor = 'blue' | 'orange' | 'green';
interface LabelConfig { color: LabelColor; img: string; showLabel: boolean; }

const LABEL_CONFIG: Record<string, LabelConfig> = {
  '0': { color: 'blue', img: '', showLabel: false },
  '1': { color: 'orange', img: 'assets/icons/oferta_destacada_estrella.svg', showLabel: true },
  '2': { color: 'green', img: 'assets/icons/icono_etiqueta_nueva.svg', showLabel: true },
  '3': { color: 'blue', img: 'assets/icons/icono_etiqueta_regular.svg', showLabel: true },
};

@Component({
  selector: 'app-offer-detail-view',
  imports: [
    NgClass,
    UpperCasePipe,
    UiImageAtomComponent,
    UiButtonAtomComponent,
    UiSponsorBadgeAtomComponent,
    UiCheckListItemAtomComponent,
    OfferInfoMoleculeComponent,
  ],
  templateUrl: './offer-detail-view.component.html',
  styleUrl: './offer-detail-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferDetailViewOrganismComponent {
  readonly data = input.required<OfferViewModel>();

  readonly backPressed = output<void>();
  readonly applyPressed = output<void>();

  protected readonly offer = computed(() => this.data());

  protected readonly logoUrl = computed(() => {
    const o = this.offer();
    return o.detail.companyLogoFlag ? (o.detail.offerLogoURL ?? '') : (o.company.entityimg ?? '');
  });

  protected readonly labelConfig = computed((): LabelConfig =>
    LABEL_CONFIG[this.offer().labelType ?? '0'] ?? LABEL_CONFIG['0']
  );

  protected readonly score = computed(() => parseInt(this.offer().detail.score ?? '0'));

  protected readonly scoreText = computed(() => {
    const s = this.score();
    if (s >= 805 && s <= 950) return 'Alto';
    if (s >= 749 && s <= 804) return 'Medio alto';
    if (s >= 677 && s <= 748) return 'Medio';
    if (s >= 403 && s <= 676) return 'Medio bajo';
    if (s >= 150 && s <= 402) return 'Bajo';
    return '';
  });

  // Clase CSS del badge de puntaje según rango de score
  protected readonly scoreBadgeClass = computed(() => {
    const s = this.score();
    if (s >= 805) return 'score-badge--alto';
    if (s >= 749) return 'score-badge--medio-alto';
    if (s >= 677) return 'score-badge--medio';
    if (s >= 403) return 'score-badge--medio-bajo';
    if (s >= 150) return 'score-badge--bajo';
    return '';
  });

  protected readonly messageDescription: readonly string[] = [
    'Buscacrédito y Experian no son entidades financieras, <strong>NO somos una plataforma</strong> en línea que facilita el acceso de clientes a productos y servicios ofrecidos por instituciones financieras asociadas y acreditadas en la plataforma. Para mayor información sobre tasas, comisiones, gastos y demás conceptos aplicables, puede recurrir al tarifario de la entidad financiera ubicado en sus oficinas y/o en su página web.',

    '<strong>Experian informa:</strong> Buscacrédito es una plataforma 100% gratuita para consumidores. Al aplicar a la oferta, la solicitud del crédito del consumidor será pre-perfilada y la finalización de la aplicación al crédito se realizará con la entidad financiera.'
  ];

}
